
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-label":"external","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M175.853 32.378a13.954 13.954 0 013.985 9.782v65c0 7.732-6.268 14-14 14s-14-6.268-14-14l-.001-30.237-63.285 63.287c-5.468 5.467-14.332 5.467-19.8 0-5.467-5.468-5.467-14.332 0-19.8l64.277-64.277H100.81c-7.732 0-14-6.268-14-14s6.268-14 14-14h65c3.806 0 7.258 1.52 9.782 3.985z","fill":"currentColor"}}),_c('path',{attrs:{"opacity":".5","d":"M170 139v18c0 9.941-8.059 18-18 18H46c-9.941 0-18-8.059-18-18V51c0-9.941 8.059-18 18-18h19","stroke":"currentColor","stroke-width":"11"}})])])
          )
        }
      }
    